// SmartMetric / SmartMetricGrid — بطاقات مؤشّرات موحّدة بألوان الحالة (ok/warn/bad).
import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { SMART_COLORS as C } from '../../theme/smartStableTheme';

const TONES = { ok: C.green, warn: C.warning, bad: C.rose, gold: C.gold, neutral: C.text };

export function SmartMetric({ label, value, tone = 'neutral', hint, accent = false }) {
  const color = TONES[tone] || C.text;
  return (
    <Card variant="outlined" sx={{ height: '100%', borderColor: accent ? color : C.line, bgcolor: accent ? `${color}12` : C.card }}>
      <CardContent>
        <Typography variant="body2" sx={{ color: C.muted, mb: 0.5 }}>{label}</Typography>
        <Typography variant="h4" sx={{ fontWeight: 900, color }}>{value}</Typography>
        {hint && <Typography variant="caption" sx={{ color: C.muted }}>{hint}</Typography>}
      </CardContent>
    </Card>
  );
}

// items: [{ label, value, tone, hint, accent, xs, md, key }]
export function SmartMetricGrid({ items = [], spacing = 2, sx }) {
  return (
    <Grid container spacing={spacing} sx={sx}>
      {items.map((it, i) => (
        <Grid item xs={it.xs ?? 6} md={it.md ?? 3} key={it.key ?? i}>
          <SmartMetric label={it.label} value={it.value} tone={it.tone} hint={it.hint} accent={it.accent} />
        </Grid>
      ))}
    </Grid>
  );
}
